import assignmentService from 'ApiService/Student/assignmentService';
import Nodatafound from 'pages/Common/Nodatafound';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { BallTriangle } from 'react-loader-spinner';
import UploadAssignment from 'pages/Student/Assignment/UploadAssignment/index';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Index = () => {
  const [assignment, setAssignment] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedAssignment, setSelectedAssignment] = useState(null);

  const fetchAssignment = async () => {
    setLoading(true);

    try {
      const response = await assignmentService.getAllPracticalAssignments({});
      if (response.data.success) {
        setAssignment(response.data.data);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || 'Failed to fetch Assignment.'
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAssignment();
  }, []);

  const handleViewPdf = (e, filePath) => {
    e.stopPropagation();
    const pdfUrl = `${BASE_URL}/${filePath.replace(/\\/g, '/')}`;
    window.open(pdfUrl, '_blank');
  };

  const renderPdfViewer = (pdfFilePath) => {
    if (!pdfFilePath) return null;

    const pdfUrl = `${BASE_URL}/${pdfFilePath.replace(/\\/g, '/')}`;

    return (
      <div className="mt-4 rounded border border-gray-300 p-2">
        <iframe
          src={`${pdfUrl}#toolbar=0`}
          width="100%"
          height="300"
          className="rounded"
          title="Assignment PDF"
        />
      </div>
    );
  };

  const handleAssignmentClick = (assignment) => {
    setSelectedAssignment(assignment);
    setShowDetails(true);
  };

  const handleBackClick = () => {
    setShowDetails(false);
    setSelectedAssignment(null);
  };

  return (
    <div className="mt-10">
      {showDetails ? (
        <div className="flex flex-col items-center">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
            Selected Assignment: {selectedAssignment?.title}
          </h2>

          <UploadAssignment
            selectedAssignment={selectedAssignment}
            handleBackClick={handleBackClick}
          />

          <div className="flex w-full justify-end px-3 pt-2 md:px-8">
            <button
              onClick={handleBackClick}
              className="mb-3 cursor-pointer rounded-xl bg-lightPrimary px-16 py-2 font-medium text-navy-700 transition duration-200 dark:bg-white/5 dark:text-white dark:hover:bg-white/10 dark:active:bg-white/20 md:mb-0"
            >
              Back
            </button>
          </div>
        </div>
      ) : loading ? (
        <div className="flex h-40 items-center justify-center">
          <BallTriangle color="#5431ed" />
        </div>
      ) : assignment.length === 0 ? (
        <div className="flex h-40 items-center justify-center dark:text-gray-600">
          <Nodatafound title="No Assignment found" />
        </div>
      ) : (
        <div className="grid h-full w-full grid-cols-1 gap-4 p-2 md:grid-cols-2 lg:grid-cols-3">
          {assignment.map((test) => (
            <div
              key={test._id}
              onClick={() => handleAssignmentClick(test)}
              className="cursor-pointer rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal text-gray-600 outline-none hover:border-brand-500 dark:border-[#323B5D] dark:bg-navy-900 dark:text-white"
            >
              <div className="w-full p-4">
                <h5 className="mb-2 text-2xl font-bold text-gray-900 dark:text-white">
                  {test?.title}
                </h5>

                {test.question && (
                  <p className="mb-2 font-normal text-gray-700 dark:text-gray-400">
                    Question: {test.question}
                  </p>
                )}

                {test.pdfFileName && (
                  <div className="mb-3">
                    <div className="flex items-center gap-2 font-normal text-gray-700 dark:text-gray-400">
                      <span>PDF File: {test.pdfFileName}</span>
                    </div>
                    <div className="mt-2">
                      <button
                        onClick={(e) => handleViewPdf(e, test.pdfFilePath)}
                        className="rounded bg-green-500 px-4 py-1 text-sm text-white"
                      >
                        View PDF
                      </button>
                    </div>
                    {/* Mini PDF preview */}
                    {test.pdfFilePath && (
                      <div
                        className="mt-2 h-16 w-full cursor-pointer overflow-hidden rounded border border-gray-300"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleViewPdf(e, test.pdfFilePath);
                        }}
                      >
                        <iframe
                          src={`${BASE_URL}/${test.pdfFilePath.replace(
                            /\\/g,
                            '/'
                          )}#toolbar=0`}
                          width="100%"
                          height="100"
                          className="pointer-events-none"
                          title={`PDF Preview ${test._id}`}
                        />
                      </div>
                    )}
                  </div>
                )}

                <p className="font-normal text-gray-700 dark:text-gray-400">
                  Due Date:{' '}
                  {new Intl.DateTimeFormat('en-GB').format(
                    new Date(test.dueDate)
                  )}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Index;
